module.exports = __webpack_public_path__ + "static/footer-texture-64953f27e82e9be5c23a9c4df6f7ded5.png";